<template>
    <div>

    <v-toolbar flat id="main-header" color="#FAFAFA" class="header-toolbar" height="110">
        <v-toolbar-side-icon class="hidden-md-and-up" @click="toggleDrawer"></v-toolbar-side-icon>
        <h1 class="hidden-md-and-down site-title" @click="$router.push('/')" > Chatbot</h1>

        <v-btn
            disabled
            class="savingStatus"
            v-if="savingStatus"
        >
            Saving ...
        </v-btn>
        <v-btn
            disabled
            class="savingStatus"
            v-else
        >
                <v-icon>done</v-icon>
            Saved
        </v-btn>
        <v-spacer></v-spacer>

        <div class="text-center mt-3" v-if="botId && usage.consumed_sessions">
            <div class="usage-progress">
                <div class="current-progress primary" :style="{width: `${Math.ceil(usage.usage_percentage)}%`}">
                    <span>{{Math.floor(usage.consumed_sessions)}} </span>
                </div>
            </div>
            <p class="font-weight-bold mb-0 mt-1">{{usage.sessions-Math.floor(usage.consumed_sessions)}} Session is left out of {{usage.sessions}} Session</p>
        </div>

        <v-spacer></v-spacer>
        <div class="rounded-card">
            <!-- <v-btn  large round color="primary" class="hidden-md-and-down" v-if="botId && $store.state.user.roleId !== 1" @click="openChat=true">
                <v-icon>comment</v-icon>
                Test Chatbot
            </v-btn> -->
            <v-menu offset-y class="user-avatar">
                <template v-slot:activator="{ on }">
                    <v-btn
                            round
                            large
                            flat
                            v-on="on"
                            class="pa-1"
                    >
                        <v-avatar
                                size="36px"
                        >
                            <img
                                    src="https://avatars0.githubusercontent.com/u/9064066?v=4&s=460"
                                    alt="Avatar"
                            >
                        </v-avatar>
                        {{ userData.first_name}} {{ userData.last_name }}
                    </v-btn>
                </template>
                <v-list>
                    <v-list-tile
                            @click="logout()"
                    >
                        <v-list-tile-title>
                            <v-icon>logout</v-icon>
                            Logout
                        </v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>
            <v-btn  large round color="#93c938" class="hidden-md-and-down white--text" to="/publish" v-if="$store.state.user.roleId === 1">
                Publish
            </v-btn>
        </div>

    </v-toolbar>
        <preview v-if="botId && openChat" :class="{openChat : openChat}" @closeChat="openChat=false"></preview>
    </div>
</template>

<script>
    import common from "../../utils/common";
    import preview from "../test-chatbot/preview";

    export default {
        components: {
            preview
        },
        data() {
            return {
                openChat: false,
                usage:''
            }
        },
        mounted(){
            this.getSessionUsage()
        },
        methods: {
            toggleDrawer () {
                this.$emit('toggleDrawer')
            },
            logout () {
                common.logOut()
            },
            getSessionUsage() {
                this.$http_without_base(`https://consumption.botter.live/v2/package?bot_id=${this.$store.state.bot.botId}`)
                  .then(response=>{
                    this.usage = response.data.data
                  })
                  .catch(error=>{
                      if (error.response && error.response.status === 401) {
                          common.logOut()
                      } else {
                          this.$store.dispatch('setErrorMessage', true)
                      }
                  })
            }
        },
        computed: {
            userData() {
                return this.$store.state.user.userData
            },
            savingStatus() {
                return this.$store.state.core.savingStatus
            },
            botId() {
                return this.$store.state.bot.botId
            }
        }
    }
</script>

<style lang="scss">


</style>

<style scoped lang="scss">
    .v-menu {
        display: inline-block;
    }
    .v-list {
        padding: 0;
    }
    .usage-progress {
        width: 300px;
        height: 18px;
        background: #97EDFF;
        border-radius: 50px;
        overflow: hidden;
    }
    .current-progress {
        height: 100%;
        border-radius: 50px;

    }
    .current-progress span {
        color: white;
        font-size: 12px;
        line-height: 15px;
        display: none;
        transition: all .5s;
    }

    .current-progress:hover span {
        display: block;
    }

</style>
